export enum ReportType {
  Actual = 'Actual',
  Target = 'Target'
}
